export default "__VITE_ASSET__200e3aa0__"